import React from "react";
import styles from "../HealthChat.module.css";

export default function SuccessScreen({ onGoToPrograms, onExploreMore }) {
  const steps = [
    "Check your email for program details and access link",
    "Complete your onboarding assessment",
    "Start your journey towards better health!",
  ];

  return (
    <div className={styles.successWrapper}>
      {/* Celebratory Header */}
      <div className={styles.successHeader}>
        <div className={styles.checkCircleLarge}>
          <svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="#4CAF50" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round">
            <polyline points="20 6 9 17 4 12" />
          </svg>
        </div>
        <h1 className={styles.successTitle}>You’re all set!</h1>
        <p className={styles.successSubtitle}>
          You’ve successfully enrolled in <br />
          <strong>PCOS Care Program 🎉</strong>
        </p>
      </div>

      {/* Next Steps Card */}
      <div className={styles.nextStepsCard}>
        <h3 className={styles.nextStepsHeading}>What’s next?</h3>
        <ul className={styles.stepsList}>
          {steps.map((step, index) => (
            <li key={index} className={styles.stepItem}>
              <div className={styles.smallCheck}>
                <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="#4CAF50" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round">
                  <polyline points="20 6 9 17 4 12" />
                </svg>
              </div>
              <span className={styles.stepText}>{step}</span>
            </li>
          ))}
        </ul>
      </div>

      {/* Action Buttons */}
      <div className={styles.successActions}>
        <button className={styles.primaryActionBtn} onClick={onGoToPrograms}>
          Go to my programs
        </button>
        <button className={styles.secondaryActionBtn} onClick={onExploreMore}>
          Explore more programs
        </button>
      </div>
    </div>
  );
}